import React, { useEffect, useState } from "react"; import { Field, FormikProvider, Form, useFormik, ErrorMessage } from "formik"; import ShowAlert from "../alert"; import MasterService from "../../Services/MasterService";
import SwaranandhraService from "../../Services/SwaranandhraService"; import { Button, Row, Col } from 'react-bootstrap'; import "jspdf-autotable";
import Container from 'react-bootstrap/Container'; import { ImNewTab } from "react-icons/im"; import { RiFileExcel2Line } from "react-icons/ri"; import { VscFilePdf } from "react-icons/vsc"; import { CiFloppyDisk } from "react-icons/ci";
import { useNavigate } from "react-router-dom"; import Menubar from "../Menubar"; import { store } from "../../App"; import { generateindicatorpdf , exportToExcelindicator} from "../utils/commonFunctions";

function SuptIndicatorMapping () {
  const [indicatorlist, setIndicatorlist] = useState(); const [indicatorslist, setIndicatorslist] = useState(); const [indicatorname, setIndicatorname] = useState(); const [data, setData] = useState([]);
  const [data1, setData1] = useState([]); const [searchText, setSearchText] = useState(""); const [searchText1, setSearchText1] = useState(""); const [start, setStart] = useState(0);
  const [distlist, setDistlist] = useState(); const [mndlist, setMndlist] = useState(); const[distenb,setDistenb]=useState(true);
  const navigate = useNavigate();
  let username = localStorage.getItem("username"); let district=localStorage.getItem("districtid"); let roleid=localStorage.getItem("role");
  const formik = useFormik({
    initialValues: {
      district: "", mandal: "", indicator_id: "", checkall: "",
      checkdata: [], checkdata1: []
    },
  })
  useEffect(() => {
    MasterService.getDistricts().then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => {
          return (
            <option key={i} value={item.id}>
              {item.value}
            </option>
          );
        });
        setDistlist(options);
      }
    });
    MasterService.getIndicators().then((resp) => {
      if (resp.data) {
        const list = Object.keys(resp.data).map((key) => ({
          key,
          id: resp.data[key]?.id,
          value: resp.data[key]?.value,
        }));
        setIndicatorlist(list);
        let options = resp.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); }); setIndicatorslist(options);
      }
    });
  }, []);
  React.useEffect(() => {
    if (roleid == 2) {
        setDistenb(true)
        district !== "0"
  ? formik.setFieldValue("district_id", district)
  : formik.setFieldValue("district_id", "");
        let params = { "district_id": district }
        MasterService.getMandals(params).then((res) => {
          if (res.data) { let options = res.data.map((item, i) => { 
            return ( <option key={i} value={item.id}> {item.value} </option> ); }); setMndlist(options); }
        });
    }
    if (roleid == 8) { setDistenb(false) } if (roleid == 5) { setDistenb(false) }
}, [])

  const MandalData = (id) => {
    let params = {
      district_id: id
    }
    MasterService.getMandals(params).then((res) => {
      if (res.data) {
        let options = res.data.map((item, i) => { return ( <option key={i} value={item.id}> {item.value} </option> ); });
        setMndlist(options);
      }
    });
  }

  const handleMandalChange = (id) => {
    let params1 =
    {
      "userId": username,
      "district_id": formik.values.district,
      "mandal_id": id,
      "button_type": "getData"
    }
    SwaranandhraService.getIndicatorMandalMapping(params1).then((res) => {
      if (res.data && res.data.SCODE === "01") {
        setData1(res.data.SDESC);
      } else {
        setData1([]);
      }
    });
  }

  const IndicatorData = (e) => {
    const filtersector = indicatorlist?.filter(
      (item) => item.id === e.target.value
    );
    setIndicatorname(filtersector[0]?.value);
    formik.setFieldValue("indicator_id", e.target.value);
    formik.setFieldValue("checkdata", []);
    let params = {
      "indicator_id": e.target.value,
      "mandal_id": formik.values.mandal,
    };
    MasterService.getSubIndicators(params).then((res) => {
      if (res.data) {
        setData(res.data);
        setStart(res.data[0].indicator_starts); 
      } else {
        setData([]);
      }
    });
  };


  const Save = () => {
    const activeSubIndicators = formik.values.checkdata
      .filter(item => item?.is_active)
      .map(item => ({
        ...item,

      }));

    if (activeSubIndicators.length === 0) {
      ShowAlert("Please select at least one indicator to map", "warning");
      return;
    }

    let params = {
      userId: username,
      indicator_id: parseInt(formik.values.indicator_id),
      district_id: formik.values.district,
      mandal_id: formik.values.mandal,
      button_type: "addIndicatorsAtAdminLevel",
      subIndicatorsList: activeSubIndicators
    };

    store.dispatch({ type: "SHOW_SPINNER" });
    SwaranandhraService.getIndicatorMandalMapping(params).then((res) => {
      if (res.data && res.data.SCODE === "01") {
        ShowAlert(res.data.SDESC, "success");
        formik.setFieldValue("checkdata", []);
        let params1 = {
          "userId": username,
          "district_id": formik.values.district,
          "mandal_id": formik.values.mandal,
          "button_type": "getData"
        };
        SwaranandhraService.getIndicatorMandalMapping(params1).then((res1) => {
          if (res1.data && res1.data.SCODE === "01") {
            setData1(res1.data.SDESC);
            let param = {
              "indicator_id": formik.values.indicator_id,
              "mandal_id": formik.values.mandal
            };
            MasterService.getSubIndicators(param).then((resp) => {
              if (resp.data) {
                setData(resp.data);
              } else {
                setData([]);
              }
            });
          }
        });
      } else if (res.data && res.data.SCODE === "02") {
        ShowAlert(res.data.SDESC, "warning");
      }
      const updatedValues = formik.values.checkdata.map((item) => ({
        ...item,
        is_active: false,
    }));
    formik.setFieldValue("checkdata", updatedValues);
    const updatedValues1 = formik.values.checkdata1.map((item) => ({
      ...item,
      is_active1: false,
  }));
  formik.setFieldValue("checkdata1", updatedValues1);
    }).finally(() => { store.dispatch({ type: "HIDE_SPINNER" }); });
  };




  const handleCheckboxChange = (e, index) => {
    const { checked } = e.target;
    formik.setFieldValue(`checkdata1[${index}].is_active1`, checked);
  };









  const handleDelete = (detail) => {
    let params = {
      "userId": username,
      "indicator_id": parseInt(detail.indicator_id),
      "sub_indicator_id": parseInt(detail.sub_indicator_id),
      "district_id": formik.values.district,
      "mandal_id": formik.values.mandal,
      "button_type": "deSelect"
    };

    SwaranandhraService.getIndicatorMandalMapping(params).then((res) => {
      if (res.data && res.data.SCODE === "01") {
        ShowAlert("Deleted Successfully", "success")
        setData1(res.data?.SDESC);
        formik.setFieldValue("indicator_id",detail.indicator_id.toString());
        const filtersector = indicatorlist?.filter(
         (item) => item.id === detail.indicator_id.toString()
       );
       setIndicatorname(filtersector[0]?.value);
               let param = {
                 "indicator_id": detail.indicator_id.toString(),
                 "mandal_id": formik.values.mandal
               };
        MasterService.getSubIndicators(param).then((resp) => {
          if (resp.data) {
            setData(resp.data);
            setStart(resp.data[0].indicator_starts);
          } else {
            setData([]);
          }
        });

      } else if (res.data && res.data.SCODE === "02") {
        ShowAlert(res.data?.SDESC, "warning");
      }
      const updatedValues = formik.values.checkdata1.map((item) => ({
        ...item,
        is_active1: false,
      }));
      formik.setFieldValue("checkdata1", updatedValues);
    });
  };
  const handleCheckboxChange1 = (e, index) => {
    const isChecked = e.target.checked;
    let updatedCheckdata = [...formik.values.checkdata];

    if (!filteredData[index]) {
      console.error('Filtered data index out of bounds');
      return;
    }

    if (!updatedCheckdata[index]) {
      updatedCheckdata[index] = {
        is_active: false,
        sub_indicator_id: filteredData[index].id,
        indicator_starts: null
      };
    }

    let newStart = start;
    
    if (isChecked) {
      updatedCheckdata[index] = {
        is_active: true,
        sub_indicator_id: filteredData[index].id,
        indicator_starts: newStart
      };
      setStart(prev => prev + 1);
    } else {
      updatedCheckdata[index] = {
        is_active: false,
        sub_indicator_id: filteredData[index].id,
        indicator_starts: null
      };

      const activeCheckboxes = updatedCheckdata.filter(item => item?.is_active);
      newStart = activeCheckboxes.length > 0 ? Math.max(...activeCheckboxes.map(item => item.indicator_starts)) + 1 : 1;
      setStart(newStart);
    }

    formik.setFieldValue('checkdata', updatedCheckdata);
    const allChecked = updatedCheckdata.every(item => item?.is_active);
    formik.setFieldValue('checkAll', allChecked);
  };


  const filterData = (data, search) => 
    search.length > 0 
      ? data?.filter(item => Object.keys(item).some(key => {
          const value = item[key];
          return value !== null && value.toString().toLowerCase().includes(search.toLowerCase());
        })) 
      : data;

  const filteredData = filterData(data, searchText1);
  const filteredData1 = filterData(data1, searchText);


  const SelectField = ({ label, name, options, handleChange, disabled }) => (
    <Col xs={12} sm={12} lg={3} md={3} xl={3} xxl={3} className={`${name}-select`}>
      <h5>{label}</h5>
      <Field
        component="select"
        name={name}
        className="form-control"
        onChange={handleChange}
        disabled={disabled}
      >
        <option value="">Select {label}</option>
        {options}
      </Field>
      <ErrorMessage name={name} component="div" style={{ color: "red" }} />
    </Col>
  );


  return (
    <>
      <Menubar />
      <Container fluid className='map-header mx-2'>
        <div className='sa-title'>
          <h2>Indicator <span>Activity Mapping</span></h2>
        </div>

      </Container>
      <FormikProvider value={formik}>
        <Form onSubmit={formik.handleSubmit}>
          <Container fluid className='mt-5'>
            <div className='mandal-container p-4'>
            <Row>
    <SelectField label="District" name="district" options={distlist} handleChange={(e) => { formik.handleChange(e); MandalData(e.target.value); }} disabled={distenb} />
    
    <SelectField label="Mandal" name="mandal" options={mndlist} handleChange={(e) => { formik.handleChange(e); handleMandalChange(e.target.value); }} />

    <SelectField label="Sector" name="indicator_id" options={indicatorslist} handleChange={(e) => { IndicatorData(e) }} />
  </Row>
            </div>

          </Container>
        </Form>
      </FormikProvider>


      <Container fluid className='d-flex justify-content-end mt-2 mb-2'>
        <Row>
          <div className=''>
            <Button className='target-btn ' onClick={() => { navigate('/dataEntryForTargets') }}>Target & Achievements Entry<ImNewTab className='ms-3' /></Button>{' '}
            <Button className='excel-btn' onClick={()=>{exportToExcelindicator(filteredData1)}}><RiFileExcel2Line className='me-2' /> Excel</Button>{' '}
            <Button className='pdf-btn'  onClick={()=>{generateindicatorpdf(filteredData1)}}><VscFilePdf className='me-2' />Pdf</Button>{' '}
          </div>
        </Row>
      </Container>
      <Container fluid >
        <FormikProvider value={formik}>
          <Form onSubmit={formik.handleSubmit}>
            <Row>
              <Col xs={12} sm={12} lg={6} md={12} xl={6} xxl={6}>
                <div className='indicators'>
                  <h5>{indicatorname || 'Select Indicators (or) Activity'}</h5>
                  <Form inline className='search-bar'>
                    <Row>
                      <Col>
                        <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearchText1(event.target.value)} />

                      </Col>
                    </Row>
                  </Form>


                  <div className='indicators-info'>
                    {filteredData?.map((detail, i) => (
                      
                        <div key={i} className="activity-box d-flex mt-2 ">
                          <Form>
                            <Field type="checkbox" name={`checkdata[${i}].is_active`} className="me-4 check-box-width" id="custom-checkbox" checked={formik.values.checkdata[i]?.is_active || false} onChange={(e) => handleCheckboxChange1(e, i)} style={{ transform: 'scale(1.4)' }} />
                          </Form>
                          <div className="number-box-main d-flex align-items-center"> <div className="number-box"><p>{i + 1}</p></div> <div className="number-text"> <p>Indicator / Activity</p> <p>  {detail.value}</p> </div> </div>
                          <div className="ha d-flex"> <div className="unit"><p>Unit</p></div> <div className="ha-box text-center"><p>{detail.unit}</p></div> </div>
                        </div>
                      ))
                    }








                  </div>
                </div>
                <Container fluid className='d-flex justify-content-end mt-2 mb-5 btn-map'>
                  <div className=''> <Button className='map-btn ' onClick={Save}>Map Indicator / Activity<CiFloppyDisk className='ms-3' /></Button>{' '} </div>
                </Container>

              </Col>
              <Col xs={12} sm={12} lg={6} md={12} xl={6} xxl={6} className="agr-secto">
                <div className='indicators1'>
                  <h5>Mapped Indicators (or) Activity</h5>
                  <Form inline className='search-bar'>
                    <Row>
                      <Col> <input type="text" className="form-control" placeholder="Search" onChange={(event) => setSearchText(event.target.value)} /> </Col>
                    </Row>
                  </Form>

                  <div className='indicators-info1'>
                    {(() => {
                      let serialNumber = 0;
                      return filteredData1?.map((detail, i) => {

                        if (!detail.indicator_name) {
                          serialNumber++;
                        }
                        return (
                          <>
                            {detail.indicator_name ?
                              (
                                <div className='agriculture-head'> <h5>{detail.indicator_name} </h5> </div>
                              ) : (
                                <div key={i} className="activity-box d-flex mt-2">
                                  <div className="number-box-main d-flex align-items-center">
                                    <div className="number-box"> <p>{serialNumber}</p> </div>
                                    <div className="number-text"> <p>Indicator / Activity</p> <p> {detail.sub_indicator_name}</p> </div>
                                  </div>

                                  <div className="ha d-flex">
                                    <div className="unit"> <p>Unit</p> </div>
                                    <div className="ha-box text-center"> <p>{detail.unit}</p> </div>
                                  </div>

                                  <Form>
                                    <Field type="checkbox" id={`custom-checkbox-${i}`} name={`checkdata1[${i}].is_active1`} checked={formik.values.checkdata1[i]?.is_active1 || false} onChange={(e) => handleCheckboxChange(e, i)} className="ms-4 me-2 check-box-width" />
                                  </Form>
                                  {formik.values.checkdata1[i]?.is_active1 === true && (
                                    <Button variant="" size="sm" onClick={() => handleDelete(detail)}> <img src="../images/bin.webp" className="img-fluid bin-img" alt="delete" /> </Button>
                                  )}
                                </div>
                              )
                            }
                          </>
                        );
                       
                      });
                    })()}
                  </div>



                </div>
              </Col>
            </Row>
          </Form>
        </FormikProvider>
      </Container>
    </>
  );
}
export default SuptIndicatorMapping;





